export const snackbarConstants = {
  Common: {
    ERROR: {
      variant: 'error',
      autoHideDuration: 5000
    },
    WARNING: {
      variant: 'warning',
      autoHideDuration: 10000
    },
    SUCCESS: {
      variant: 'success',
      autoHideDuration: 1500
    },
    INFO: {
      variant: 'info',
      autoHideDuration: 3000
    },
    NOTICE: {
      variant: 'info',
      autoHideDuration: 20000
    }
  },
  Mobile: {
    anchorOrigin: { vertical: 'bottom', horizontal: 'center' }
  }
};
